import { createFileRoute } from "@tanstack/react-router";

import { ClientTransfersContainer } from "@/features/organisation/containers/client-transfers-container";

export const Route = createFileRoute("/organisation/client-transfers")({
  component: ClientTransfersContainer,
});
